import { useForm, useController } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPlus, faMinus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { TransformComponent, TransformWrapper, useControls } from 'react-zoom-pan-pinch';

const Controls = () => {
  const { zoomIn, zoomOut, resetTransform } = useControls();

  return (
    <div className="tools">
      <button
        className="bg-transparent btn btn-outline-secondary app-txt-granite-80-dark px-2 py-1"
        onClick={() => zoomIn()}
      >
        <FontAwesomeIcon className="app-fs-12" icon={faPlus} />
      </button>
      <button
        className="bg-transparent btn btn-outline-secondary app-txt-granite-80-dark px-2 py-1 mx-1"
        onClick={() => zoomOut()}
      >
        <FontAwesomeIcon className="app-fs-12" icon={faMinus} />
      </button>
      <button
        className="bg-transparent btn btn-outline-secondary app-txt-granite-80-dark px-2 py-1"
        onClick={() => resetTransform()}
      >
        <FontAwesomeIcon className="app-fs-12" icon={faXmark} />
      </button>
    </div>
  );
};

function CardWelcomeModal({ show, handleClose, control, defaultValue }) {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const imageSrc = currentLanguage === 'es' ? 'new-tourism-es.png' : 'new-tourism-en.png';
  // Integracion con React Hook Form
  const {
    field: { onChange, name, value },
    fieldState: { error },
  } = useController({
    name: 'acceptWelcome',
    control,
    rules: { required: true },
    defaultValue,
  });

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      contentClassName="border-0"
      size="lg"
    >
      <Modal.Header className="pt-3 pb-4 app-txt-granite border-0 shadow-none" closeButton>
        {/* <Modal.Title className="mx-auto">
          <p className="mb-0 app-txt-red">Aviso</p>
        </Modal.Title> */}
      </Modal.Header>
      <Modal.Body className="lh-sm overflow-auto px-0 pb-1">
        {/* <img src="new-tourism.png" alt="antidrogas" className="img-fluid" /> */}
        <TransformWrapper initialScale={1} initialPositionX={200} initialPositionY={100}>
          {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
            <div className="position-relative">
              <TransformComponent>
                {/* <img src="new-tourism-es.png" alt="antidrogas" className="img-fluid" /> */}
                <img src={imageSrc} alt="antidrogas" className="img-fluid" />
              </TransformComponent>
              <div className="position-absolut bottom-0 z-2 mb- ms-1">
                <Controls />
              </div>
            </div>
          )}
        </TransformWrapper>
      </Modal.Body>
      <Modal.Footer className="border-0 mx-auto d-block mt-0 pt-0">
        <Form.Check className="mb-2 mx-auto ps-3" type="checkbox" id="cardRegiter">
          <Form.Check.Label className="custom-input-checkbox">
            <Form.Check.Input
              checked={value}
              type="checkbox"
              onChange={onChange}
              // onBlur={handleOnBlur}
              name={name}
            />
            <span className="checkmark">
              <FontAwesomeIcon icon={faCheck} />
            </span>
            <span className="label-text">{t('TXT_BTN_ACCEPT')}</span>
          </Form.Check.Label>
        </Form.Check>
        <Button
          variant=""
          onClick={handleClose}
          disabled={!value}
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height border-0"
        >
          {t('TXT_BOTON_CONTINUE')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CardWelcomeModal;
